import * as React from "react";
import {Typography} from "antd";
import DisplayLink from "./shared/DisplayLink";
import styled from "styled-components";

const { Text} = Typography;

const InlineCode = styled.span`
    background-color: ${props => props.theme.colors.lightestGray};
    border: ${props => `.1rem solid ${props.theme.colors.mediumGrayDark}`};
    border-radius: 0.4rem;
    font-family: ${props => props.theme.fontFamily.code};
    padding: 0.1rem 0.2rem;
    margin-inline: 2px;
    
    && {
        font-size: ${props => props.theme.fontSize.code};
    }
`

const SentenceLink = styled.span`
   margin-left: 0.25rem;
`

const TextWithPatterns = ({description}) => <>
    { description.map((blocks, i) => (
        <p key={i}>
            {blocks.map((block, index) => {
                if(block.type === "text" ) {
                    return <Text key={index}>{block.content}</Text>
                }
                if(block.type === "code" ) {
                    return <InlineCode key={index}>{block.content}</InlineCode>
                }
                return <SentenceLink><DisplayLink key={index} linkObject={block}/></SentenceLink>
            })}
        </p>))
    }
</>;

export default TextWithPatterns;
